import { UserModuleType, WorkCategory } from "@tm/models"
import { useMemo } from "react"
import { useLocalization } from "@tm/localization"
import { keyBy, mapValues } from "lodash"
import { useUser } from "@tm/context-distribution"

type WorkCategoryItem = {
    category: WorkCategory
    text: string
    hourlyRate: number
}

export function useWorkCategoryItems() {
    const { userContext, userSettings: { hourlyRates } = {} } = useUser()
    const { translateText } = useLocalization()
    return useMemo(() => {
        const items: WorkCategoryItem[] = []
        const hourlyRateRecord = mapValues(keyBy(hourlyRates, "category"), "hourlyRate")
        const defaultHourlyRate = hourlyRateRecord.undefined ?? 0
        items.push(
            {
                category: WorkCategory.WorkshopWork,
                text: translateText(248),
                hourlyRate: hourlyRateRecord[WorkCategory.WorkshopWork] ?? defaultHourlyRate,
            },
            {
                category: WorkCategory.BodyWork,
                text: translateText(249),
                hourlyRate: hourlyRateRecord[WorkCategory.BodyWork] ?? defaultHourlyRate,
            },
            {
                category: WorkCategory.AccessoryWork,
                text: translateText(250),
                hourlyRate: hourlyRateRecord[WorkCategory.AccessoryWork] ?? defaultHourlyRate,
            },
            {
                category: WorkCategory.PaintWork,
                text: translateText(251),
                hourlyRate: hourlyRateRecord[WorkCategory.PaintWork] ?? defaultHourlyRate,
            },
            {
                category: WorkCategory.ElectricalWork,
                text: translateText(252),
                hourlyRate: hourlyRateRecord[WorkCategory.ElectricalWork] ?? defaultHourlyRate,
            },
            {
                category: WorkCategory.ElectronicWork,
                text: translateText(253),
                hourlyRate: hourlyRateRecord[WorkCategory.ElectronicWork] ?? defaultHourlyRate,
            },
            {
                category: WorkCategory.Diagnose,
                text: translateText(12981),
                hourlyRate: hourlyRateRecord[WorkCategory.Diagnose] ?? defaultHourlyRate,
            }
        )

        const ereModule = userContext?.modules?.find((x) => x.type === UserModuleType.TMDamageCalculationEurotax)
        if (ereModule) {
            items.push(
                {
                    category: WorkCategory.SaddlerWork,
                    text: translateText(929),
                    hourlyRate: hourlyRateRecord[WorkCategory.SaddlerWork] ?? defaultHourlyRate,
                },
                {
                    category: WorkCategory.SmartRepair,
                    text: translateText(930),
                    hourlyRate: hourlyRateRecord[WorkCategory.SmartRepair] ?? defaultHourlyRate,
                }
            )
        }

        return items
    }, [hourlyRates, translateText, userContext?.modules])
}
